import { render, staticRenderFns } from "./AdminOrderStatistic.vue?vue&type=template&id=989cea8a&"
import script from "./AdminOrderStatistic.vue?vue&type=script&lang=js&"
export * from "./AdminOrderStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports